import template from './positionsTable.html';
import controller from './positionsTable.controller';

export default {
  restrict: 'E',
  bindings: {
    oldPositions: '<',
    transfer: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};



// WEBPACK FOOTER //
// ./src/app/common/ui/positionsTable/positionsTable.component.js